import EffectiveDateView from 'text!../views/effective-date.html';
import EffectiveDateCtrl from '../controllers/EffectiveDateCtrl';

export default () => {

    const wizardParentState = 'baseTransactionWizard';

    return {
        effectiveDate: {
            name: 'effectiveDate',
            parent: wizardParentState,
            controller: EffectiveDateCtrl,
            template: EffectiveDateView
        }
    };
};